<template>
  <d-card class="card-small">
    <d-card-header class="border-bottom">
      <h6 class="m-0">Printers</h6>
      <div class="block-handle"></div>
    </d-card-header>
    <d-card-body class="p-0">
      <d-list-group flush class="list-group-small">
        <d-list-group-item
          v-for="(item, idx) in printers"
          :key="idx"
          class="d-flex px-3 bg-transparent"
          :title="prettyTime(item.last_checkin)"
        >
          <span class="text-semibold text-fiord-blue">{{ item.name }}</span>
          <span
            v-if="item.is_online"
            class="ml-auto text-right text-semibold text-reagent-gray"
          >
            ONLINE
            <i class="material-icons text-success">check_circle</i>
          </span>
          <span
            v-else
            class="ml-auto text-right text-semibold text-reagent-gray"
          >
            OFFLINE
            <i class="material-icons text-danger">highlight_off</i>
          </span>
        </d-list-group-item>
      </d-list-group>
    </d-card-body>
  </d-card>
</template>

<script>
import moment from 'moment'

export default {
  name: "printers",
  computed: {
    printers() {
      return this.$store.state.printers.printers;
    }
  },
  created() {
    this.$store.dispatch("printers/initPrinters");
  },
  methods: {
    prettyTime(timeStamp) {
      return moment(timeStamp).calendar();
    }
  }
};
</script>
